export const AdminBoardFieldOptionController = {
    index(): void {},
    store(): void {},
    reorder(): void {},
    update(): void {},
    destroy(): void {},
};
